/** @description リンク先の表示場所 */
export enum LinkOpenTargetEnum {
  // 現在の閲覧コンテキスト
  SELF = '_self',
  // 新しいタブ
  BLANK = '_blank',
  // 親の閲覧コンテキスト
  PARENT = '_parent',
  // 最上位の閲覧コンテキスト
  TOP = '_top',
}

/** @description HTTP メソッド */
export enum HTTPMethodsEnum {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
}

export { UserRoleEnum } from './userRoleEnum'
export { UserDetailPageModeEnum } from './user/userInfoDisplayEnum'
export { SortTypeEnum } from './sortTypeEnum'
export { UnderTitleMessageType, ResponseMessageTypeEnum } from './messageEnum'
export { BaseButtonTypeEnum } from './buttonEnum'
export { CharBoolean } from './charBooleanEnum'
export { ManagementCodesEnum, CodesEnum } from './codesEnum'
export { TransactionStatusEnum } from './transactionStatusEnum'
export { DeleteFileTextEnum } from './deleteFileEnum'
export { FileTypeEnum } from './fileTypeEnum'
export { ApiResponseStatusEnum } from './apiResponseStatusEnum'
export { FormInputTypeEnum } from './formInputTypeEnum'
export { FolderTypeEnum } from './folderTypeEnum'
export { BulkUploadFilesFlagEnum } from './bulkUploadFilesFlagEnum'
export { DocumentTypeEnum } from './documentTypeEnum'
export { ProductCompanyTypeEnum } from './productCompanyTypeEnum'
export { PageSize } from './pageEnum'
